import { render, staticRenderFns } from "./PreviewGood.vue?vue&type=template&id=6304b991&scoped=true"
import script from "./PreviewGood.vue?vue&type=script&lang=js"
export * from "./PreviewGood.vue?vue&type=script&lang=js"
import style0 from "./PreviewGood.vue?vue&type=style&index=0&id=6304b991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304b991",
  null
  
)

export default component.exports